import { render, staticRenderFns } from "./EmployeeHistoryList.vue?vue&type=template&id=6c0c5268&scoped=true&"
import script from "./EmployeeHistoryList.vue?vue&type=script&lang=js&"
export * from "./EmployeeHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeHistoryList.vue?vue&type=style&index=0&id=6c0c5268&scoped=true&lang=css&"
import style1 from "@/styles/user-quote.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c5268",
  null
  
)

export default component.exports